































































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import AddOrEditDirectory from './components/AddOrEditDirectory.vue'
import AddOrEditDirectoryGroup from './components/AddOrEditDirectoryGroup.vue'
import { getTreeData } from './components/handleTree'
import {
  TransferDirectoryGroupServiceProxy,
  TransferDirectoryQueryServiceProxy,
  TransferDirectoryServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'

const transferDirectoryGroupServiceProxy = new TransferDirectoryGroupServiceProxy()
const transferDirectoryQueryServiceProxy = new TransferDirectoryQueryServiceProxy()
const transferDirectoryServiceProxy = new TransferDirectoryServiceProxy()

const treeData: any = [{
  title: 'page_transport_directory_group',
  id: '0',
  data: { allPath: '/0', id: '0', name: 'page_transport_directory_group' },
  children: [],
  scopedSlots: { title: 'custom' }
}]
export default Vue.extend({
  components: {
    AddOrEditDirectory,
    AddOrEditDirectoryGroup
  },
  data() {
    return {
      limit: false,
      showAddModal: false,
      showAddGroupModal: false,
      replaceFields: {
        key: 'id'
      },
      // treeData: [
      //   {
      //     title: 'page_transport_directory',
      //     id: '0',
      //     data: { allPath: '/0', id: '0', name: 'page_transport_directory' },
      //     children: [],
      //     scopedSlots: { title: 'custom' }
      //   }
      // ] as any,
      expandedKeys: ['0'] as any, // 展开的树节点id
      selectedKeys: ['0'], // 选中的树节点id
      // selectedTreeItem: { name: this.$t('transport_directory'), allPath: '/0', id: '0' }, // 选中的树节点item
      actionType: '0', // 目录分组的操作类型：0 新增子目录，1 重命名
      directoryGroupParams: {} as any, // 目录分组的属性
      dirList: [] as any, // 工位文件列表
      dirActionType: 'add', // 工位文件的操作类型add，edit
      editDirectoryData: {} as any, // 编辑工位文件详情
      showGroupAction: false, // 是否展示分组的下拉菜单
      treeList: [], // 用于国际化处理
      selectedTree: {}
    }
  },
  computed: {
    ...mapGetters(['buttons']),
    treeData() {
      return [{
        title: this.$t(treeData[0].title),
        id: '0',
        data: { allPath: '/0', id: '0', name: this.$t(treeData[0].title) },
        children: this.treeList,
        scopedSlots: { title: 'custom' }
      }]
    },
    selectedTreeItem() {
      this.selectedTree = { name: this.$t('page_transport_directory_name'), allPath: '/0', id: '0' }
      return { name: this.$t('page_transport_directory_name'), allPath: '/0', id: '0' }
    }
  },
  watch: {
    buttons: {
      handler(val) {
        // console.log('buttons:', val)
        let btn1 = 'page_setting_transport_directory_create_subdirectory'
        let btn2 = 'page_setting_transport_directory_rename'
        let btn3 = 'page_setting_transport_directory_delete_group'
        this.showGroupAction = !!(val.includes(btn1) || val.includes(btn2) || val.includes(btn3))
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getTreeData()
  },
  methods: {
    // 轮询树
    handleTreeData(data: any) {
      data.map((item: any) => {
        item = Object.assign(item, { scopedSlots: { title: 'custom' } })
        if (item.children.length) {
          this.handleTreeData(item.children)
        }
      })
      return data
    },
    getTreeData() {
      transferDirectoryGroupServiceProxy.treeList().then(res => {
        // this.treeData = res
        if (res && res.length) {
          this.treeList = this.handleTreeData(res)
          this.treeData[0].children = this.handleTreeData(res)
        } else {
          this.treeList = []
          this.treeData[0].children = []
        }
        if (this.treeData[0].children.length) { // 默认展开一级节点
          this.expandedKeys.push(this.treeData[0].children[0].id)
        }
        if (this.treeData.length) {
          this.getDirectoryList()
        }
      })
    },
    // 获取组下面的所有工位文件
    getDirectoryList() {
      transferDirectoryQueryServiceProxy.list(this.selectedKeys[0]).then((res: any) => {
        // console.log('工位文件:', res)
        if (res) {
          this.dirList = res
        }
      })
    },
    onExpand(expandedKeys: any) {
      this.expandedKeys = expandedKeys
    },
    onSelect(selectedKeys: any, info: any) {
      this.selectedKeys = selectedKeys
      if (this.selectedKeys.length) {
        // console.log('selected', selectedKeys, info.selectedNodes[0].data.props.data)
        this.selectedTree = info.selectedNodes[0].data.props.data
        this.getDirectoryList()
      } else {
        this.selectedTree = {}
      }
    },
    // 操作目录分组
    handleAction(key: any, item: any) {
      console.log(key, item)
      if (key === '1') { // 新建子目录
        this.directoryGroupParams = {
          parentAllPath: item.data.allPath,
          parentId: item.id
        }
        this.actionType = '0'
        this.showAddGroupModal = true
      } else if (key === '2') { // 重命名
        this.directoryGroupParams = {
          id: item.id,
          name: item.title,
          parentAllPath: item.data.allPath,
          parentId: item.parentId
        }
        this.actionType = '1'
        this.showAddGroupModal = true
      } else { // 删除
        this.showDelGroupConfirm(item)
      }
    },
    // 关闭新建子目录或重命名弹框
    closeAddGroupModal(reload?: boolean) {
      this.showAddGroupModal = false
      if (reload) {
        this.getTreeData()
      }
    },
    // 关闭新建目录或编辑目录的弹框
    closeAddDirModal(reload?: boolean) {
      this.showAddModal = false
      if (reload) {
        this.getDirectoryList()
      }
    },
    onChange(checked: any) {
      this.limit = checked
    },
    // 打开编辑、新建目录弹框
    openAddModal(type?: string, dir?: any) {
      if(this.selectedTree.hasOwnProperty('id')) {
        this.showAddModal = true
        if (type === 'edit') {
          this.dirActionType = 'edit'
          this.editDirectoryData = dir
        } else {
          this.dirActionType = 'add'
        }
      } else {
        this.$message.error(this.$t('page_setting_err_tip'))
      }
    },
    // 删除分组目录
    showDelGroupConfirm(item: any) {
      this.$confirm({
        title: this.$t('delete_directory_group_confirm_title') + `：${item.title}?`,
        content: this.$t('delete_directory_group_confirm_content'),
        okText: this.$t('ok'),
        cancelText: this.$t('cancel'),
        onOk:()=> {
          return new Promise((resolve, reject) => {
            transferDirectoryGroupServiceProxy.delete(item.id).then((res: any) => {
              this.getTreeData()
              resolve()
            })
          })
        }
      })
    },
    // 删除工位文件
    showDelDirectoryConfirm(item: any) {
      this.$confirm({
        title: this.$t('delete_directory_confirm_title') + `：${item.name}?`,
        content: this.$t('delete_directory_confirm_content'),
        okText: this.$t('ok'),
        cancelText: this.$t('cancel'),
        onOk:()=> {
          return new Promise((resolve, reject) => {
            transferDirectoryServiceProxy.delete(item.id).then((res: any) => {
              this.getDirectoryList()
              resolve()
            })
          })
        }
      })
    }

  }
})
